<template>
 <router-view></router-view>
</template>

<script>
export default {
  name: "Pfs",
};
</script>
<style lang="scss">
</style>